/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import dynamicTypeSpeed from './dynamicTypeSpeed';
import HTML from 'react-native-render-html';
let prevMessage = ''; // Global constant to store the previous message

function useTypingAnimation(message, doneAnimatingText, hasAnimation) {
  const [characters, setCharacters] = useState('');
  // const animationRef =
  //   React.useRef<(value: void | PromiseLike<void>) => void>();

  useEffect(() => {
    let animationCancelled = false;

    // Check if the message is the same as the previous one
    if (prevMessage === message && message.length > 0 && characters.length > 0) {
      return;
    } else {
      prevMessage = message;
    }

    // Reset characters when message changes
    setCharacters('');
    if (hasAnimation) {
      async function typeWriter() {
        for (let i = 0; i < message.length; i++) {
          if (animationCancelled) {
            return;
          }
          setCharacters(prevCharacters => prevCharacters + message.charAt(i));
          if (hasAnimation) {
            await new Promise(resolve => {
              setTimeout(resolve, dynamicTypeSpeed(message.charAt(i)));
            });
          }
        }
        if (hasAnimation) {
          setTimeout(() => doneAnimatingText(true), 1000);
        }
      }
      typeWriter();
    } else {
      setCharacters(message);
      doneAnimatingText(true);
    }
    return () => {
      animationCancelled = true;
      doneAnimatingText(false);
    };
  }, [doneAnimatingText, hasAnimation, message]);
  return characters;
}
export const TypeWriterAnimation = _ref => {
  let {
    message,
    hasAnimation,
    textStyle,
    doneAnimatingText
  } = _ref;
  const characters = useTypingAnimation(message, doneAnimatingText, hasAnimation);
  const htmlContent = characters.replace(/º/g, '<br/>');

  // Extract relevant properties from TextStyle
  const {
    fontSize,
    color,
    lineHeight,
    textAlign,
    fontWeight
  } = textStyle || {};
  // Create a new style object with the extracted properties
  const mixedTextStyle = {
    fontSize,
    color,
    fontWeight,
    lineHeight,
    textAlign
  };
  return /*#__PURE__*/React.createElement(View, {
    style: styles.container
  }, /*#__PURE__*/React.createElement(HTML, {
    source: {
      html: htmlContent
    },
    baseStyle: mixedTextStyle
  }));
  // return (
  //   <Text style={[styles.container, textStyle]}>
  //     {characters.split('º').map((p, i) => (
  //       <Typography.H6 key={'p_' + i} textStyle={textStyle}>
  //         {p}
  //       </Typography.H6>
  //     ))}
  //   </Text>
  // );
};

const styles = StyleSheet.create({
  container: {
    marginTop: 8
  }
});
//# sourceMappingURL=TypeWriterAnimation.js.map